import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Container } from './styles';
import { Direction } from './Direction';

interface Props {
  onClick?: () => void;
}

export const DirectionSwitcher: React.FC<Props> = observer(({ onClick }) => {
  const { t } = useTranslation('conversion');

  return (
    <Container>
      <Direction onClick={onClick} currencyFrom="RUB">
        {t('Rubles to dollars')}
      </Direction>
      <Direction onClick={onClick} currencyFrom="USD">
        {t('Dollars to rubles')}
      </Direction>
    </Container>
  );
});
